import {IError} from '../types/interface/inscription';

export const showErrorValuesDefault = {
  nom: false,
  prenom: false,
  telephone: false,
  email: false,
  ville: false,
  adresse: false,
  password: false,
  image: false,
  cin: false,
  passwordConfirmation: false,
  dateNaissance: false,
};

export const showErrorValuesSubmit = {
  nom: true,
  prenom: true,
  telephone: true,
  email: true,
  ville: true,
  adresse: true,
  password: true,
  image: true,
  cin: true,
  passwordConfirmation: true,
  dateNaissance: true,
};

export const defaultValues: IError = {
  nom: '',
  prenom: '',
  telephone: '',
  email: '',
  ville: '',
  adresse: '',
  password: '',
  image: '',
  cin: '',
  passwordConfirmation: '',
  dateNaissance: '',
  acceptedCondition: true,
};

export const TitleLabels = {
  contractant: {
    nom: 'Nom',
    prenom: 'Prénom(s)',
    telephone: 'Téléphone',
    email: 'Email',
    ville: 'Ville',
    adresse: 'Adresse',
    password: 'Mot de passe ',
    passwordConfirmation: 'Confirmer Votre mot de passe ',
    image: '',
    cin: 'CIN (recto et verso)',
    dateNaissance: 'Date de naissance',
  },
};
